/**
 * Name: AddSongs
 * Author: @Gaurav
 * Date: 20-07-2021
 */
import React, { useState } from 'react';
import Sidebar from '../../components/SideBar';
import NavBar from '../../components/NavBarSearchSong';
import DftButton from '../../components/Button';
import Settings from '../../assets/Settings.png';
import '../AddSong/Addsong.scss';
import SelectedSongsListSection from './SelectedSongsListSection';
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';
import ProgressBar from '../../components/ProgressBar';
import { useHistory } from 'react-router-dom';
import { _showAlert } from '../../utils';
import { uploadSongs } from '../../services/SongUploadService';

const uploadPhaseLabels = {
  queued: 'Waiting',
  metadata: 'Reading metadata',
  starting: 'Starting',
  uploading: 'Uploading',
  artwork: 'Uploading artwork',
  finalizing: 'Finalizing',
  complete: 'Complete',
};

function AddSongs() {
  const [newSelectedSongsList, setNewSelectedSongs] = useState([]);
  const [isUploadingSongs, setUploadingSongs] = useState(false);
  const [uploadProgress, setUploadProgress] = useState({
    completed: 0,
    total: 0,
    currentFileName: '',
    currentPercent: 0,
    phase: '',
    songs: [],
  });
  const history = useHistory();
  /**
   * Add Songs functionality
   */
  const handleUpload = () => {
    document.getElementById('song-picker').click();
  };

  const handleFileSelect = (event) => {
    setNewSelectedSongs(Array.from(event.target.files || []));
    event.target.value = '';
  };

  const handleUploadClick = async () => {
    const files = Object.values(newSelectedSongsList);
    if (!files.length || isUploadingSongs) return;

    setUploadingSongs(true);
    setUploadProgress({
      completed: 0,
      total: files.length,
      currentFileName: files[0]?.name || '',
      currentPercent: 0,
      phase: 'starting',
      songs: files.map((file) => ({
        name: file.name,
        percent: 0,
        phase: 'queued',
      })),
    });

    try {
      await uploadSongs(files, {
        onProgress: ({ file, fileIndex, fileCount, percent, phase, completedCount }) => {
          setUploadProgress((previousProgress) => {
            const songs = previousProgress.songs?.length
              ? [...previousProgress.songs]
              : files.map((songFile) => ({
                  name: songFile.name,
                  percent: 0,
                  phase: 'queued',
                }));

            songs[fileIndex] = {
              ...(songs[fileIndex] || {}),
              name: file.name,
              percent: percent ?? 0,
              phase,
            };

            return {
              completed: completedCount ?? (phase === 'complete' ? fileIndex + 1 : fileIndex),
              total: fileCount,
              currentFileName: file.name,
              currentPercent: percent ?? 0,
              phase,
              songs,
            };
          });
        },
      });

      _showAlert(`${files.length} song${files.length > 1 ? 's' : ''} added successfully`, 'success');
      history.push('/search-songs');
    } catch (error) {
      _showAlert(error?.message || 'Failed to upload songs', 'error', 10000);
      setUploadingSongs(false);
    }
  };

  const getVisibleUploadRows = () => {
    const songs = (uploadProgress.songs || []).map((song, index) => ({ ...song, index }));
    const activeSongs = songs.filter(({ phase }) => phase && phase !== 'queued' && phase !== 'complete');

    if (activeSongs.length) return activeSongs.slice(0, 2);

    const completedSongs = songs.filter(({ phase }) => phase === 'complete').slice(-2);
    return completedSongs.length ? completedSongs : songs.slice(0, 2);
  };

  const renderView = () => {
    if (isUploadingSongs) {
      const visibleUploadRows = getVisibleUploadRows();

      return (
        <Box width="100%" height="60vh" display="flex" justifyContent="center" alignItems="center">
          <Box width="48%" textAlign="center">
            <Typography className="uploading-text">
              Uploading[{uploadProgress.completed}/{uploadProgress.total}]...
            </Typography>
            <div className="uploading-song-list">
              {visibleUploadRows.map((song) => (
                <div className="uploading-song-row" key={`${song.index}-${song.name}`}>
                  <div className="uploading-song-header">
                    <Typography className="uploading-file-text">{song.name}</Typography>
                    <Typography className="uploading-file-text">
                      {uploadPhaseLabels[song.phase] || 'Uploading'} {typeof song.percent === 'number' ? `(${song.percent}%)` : ''}
                    </Typography>
                  </div>
                  <ProgressBar value={song.percent} />
                </div>
              ))}
            </div>
          </Box>
        </Box>
      );
    }
    if (newSelectedSongsList?.length > 0) {
      return <SelectedSongsListSection songs={newSelectedSongsList} onUploadClick={handleUploadClick} />;
    }
    return (
      <>
        <DftButton onClick={handleUpload} button="Choose Songs" />
        <input
          type="file"
          id="song-picker"
          style={{ display: 'none' }}
          onChange={handleFileSelect}
          multiple={true}
          accept="audio/mp3,audio/*;capture=microphone"
        />
      </>
    );
  };
  return (
    <div className="main empty_page">
      <div className="sidebar">
        <Sidebar />
      </div>
      <div className="leftPortion">
        <NavBar data="Add song" icon={Settings} currentRouteName="Songs" breadcrumbsPath="Add Songs / Songs List" />
        <div className="content empty_row">{renderView()}</div>
      </div>
    </div>
  );
}
export default AddSongs;
